import { untrack } from 'solid-js';
import { getFieldArrayNames } from './getFieldArrayNames';
import { getFieldArrayStore } from './getFieldArrayStore';
import { getPathIndex } from './getPathIndex';
/**
 * Removes invalid field or field array names of field arrays.
 *
 * @param form The form of the field array.
 * @param names The names to be filtered.
 */
export function removeInvalidNames(form, names) {
    getFieldArrayNames(form, false).forEach((fieldArrayName) => {
        const lastIndex = untrack(getFieldArrayStore(form, fieldArrayName).items.get).length - 1;
        names
            .filter((name) => name.startsWith(`${fieldArrayName}.`) &&
            getPathIndex(fieldArrayName, name) > lastIndex)
            .forEach((name) => {
            names.splice(names.indexOf(name), 1);
        });
    });
}
